export default __webpack_public_path__ + "cbc7fbd832ee8eb02ac06a1e8de27dcf.png";